module.exports = __webpack_public_path__ + "static/media/top-slide-1.d774a4aa.avif";